import { useSubcontractStatesQuery } from '../../generated/graphql';
import { FilterProps } from '../../types/types';
import { SelectFilter } from '../SelectFilter/SelectFilter';

export default function SubcontractStateFilter(props: FilterProps) {
    const { value, onChange } = props
    const query = useSubcontractStatesQuery
    return (
        <SelectFilter
            value={value}
            onChange={onChange}
            label="Estado"
            query={query}
            field="contractConcessionOrganizationState"
            multiple={true}
        />
    )
}
